import AssignPermissionsForm from "./AssignPermissionsForm";
export default AssignPermissionsForm;
